<template>
  <div class="ml-button" style="display: inline-block;">
    <el-button type="primary" icon="el-icon-upload2" plain @click="eventClick">导入</el-button>

    <el-drawer
      :visible.sync="show"
      :close-on-press-escape="false"
      title="导入"
      custom-class="ml-import-drawer"
      modal-append-to-body
      append-to-body
      @before-close="callbackClose"
    >
      <ml-import-step1 v-if="step===1" :module="module" @success="callbackUpload" />
      <ml-import-step2 v-else ref="step2" :module="module" />
    </el-drawer>
  </div>
</template>
<script>
import MlImportStep1 from './components/step-1.vue'
import MlImportStep2 from './components/step-2.vue'

export default {
  name: 'MlImport',
  components: { MlImportStep2, MlImportStep1 },
  props: {
    module: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      show: false,
      step: 1
    }
  },
  methods: {
    eventClick: function() {
      this.show = true
      this.step = 1
    },
    callbackUpload(collection) {
      this.step = 2
      this.$nextTick(() => {
        this.$refs.step2.setData(collection)
      })
    },
    callbackClose: function() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss">
.ml-import-drawer {
  width: 1200px !important;

  .el-drawer__title {
    border-top-left-radius: 10px !important;
  }

  .el-drawer__header {
    font-size: 16px !important;
    color: #333333 !important;
    font-weight: 700;
    text-align: center;
  }

  .el-drawer__body {
    border-bottom-left-radius: 10px !important;
    padding: 0 20px;
  }
}
</style>
